<template> <!-- 收件人信息 -->
  <el-form
    ref="ruleForm"
    class="demo-ruleForm" label-position="top"
  >
    <el-row :gutter="20">
      <el-col :span="8">
        <!-- 姓名 -->
        <el-form-item :label="$t('newOrder.SenderName')">
          <encryption-field
            field-name="senderName"
            :encrypted-value="ruleForm.senderName"
            :label="$t('newOrder.SenderName')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 公司 -->
        <el-form-item :label="$t('newOrder.SenderCompany')">
          <encryption-field
            field-name="senderCompany"
            :encrypted-value="ruleForm.senderCompany"
            :label="$t('newOrder.SenderCompany')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 手机 -->
        <el-form-item :label="$t('newOrder.senderPhone')">
          <encryption-field
            field-name="senderMobile"
            :encrypted-value="ruleForm.senderMobile"
            :label="$t('newOrder.senderPhone')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 街道 -->
        <el-form-item :label="$t('driver.modalStreet')">
          <encryption-field field-name="senderStreet" :encrypted-value="ruleForm.senderStreet" label="senderStreet" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 门牌号 -->
        <el-form-item :label="$t('newOrder.SenderNumber')">
          <encryption-field field-name="senderHouseNumber" :encrypted-value="ruleForm.senderHouseNumber" label="senderHouseNumber" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 区 -->
        <el-form-item :label="$t('newOrder.SenderDistrict')">
          <encryption-field field-name="senderArea" :encrypted-value="ruleForm.senderArea" label="senderArea" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 城市 -->
        <el-form-item :label="$t('newOrder.SenderCity')">
          <encryption-field field-name="senderCity" :encrypted-value="ruleForm.senderCity" label="senderCity" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 州 -->
        <el-form-item :label="$t('newOrder.SenderState')">
          <encryption-field field-name="senderState" :encrypted-value="ruleForm.senderState" label="senderState" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 邮编 -->
        <el-form-item :label="$t('newOrder.SenderZipCode')">
          <encryption-field field-name="senderZipcode" :encrypted-value="ruleForm.senderZipcode" label="senderZipcode" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 地址补充 -->
        <el-form-item :label="$t('GlobalSetObj.sendderComplement')">
          <encryption-field
            field-name="senderComplement"
            :encrypted-value="ruleForm.senderComplement"
            :label="$t('GlobalSetObj.sendderComplement')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 税号 -->
        <el-form-item :label="$t('newOrder.SenderCPF')">
          <encryption-field
            field-name="senderTax"
            :encrypted-value="ruleForm.senderTax"
            :label="$t('newOrder.SenderCPF')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 州注册号 -->
        <el-form-item :label="$t('navbar.senderIe')">
          <encryption-field field-name="senderIeNumber" :encrypted-value="ruleForm.senderIeNumber" label="senderIeNumber" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <!-- 地址 -->
        <el-form-item :label="$t('newOrder.SendingAddress')">
          <encryption-field
            field-name="senderAddress"
            :encrypted-value="ruleForm.senderAddress"
            :label="$t('newOrder.SendingAddress')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 电话 -->
        <el-form-item :label="$t('newOrder.SenderPhone')">
          <encryption-field
            field-name="senderPhone"
            :encrypted-value="ruleForm.senderPhone"
            :label="$t('newOrder.SenderPhone')"
          />

        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- 邮箱 -->
        <el-form-item :label="$t('newOrder.SenderEmail')">
          <encryption-field
            field-name="senderMail"
            :encrypted-value="ruleForm.senderMail"
            :label="$t('newOrder.SenderEmail')"
          />

        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: '',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'encryption-field': () => import('@/components/EncryptionField/index.vue')
  },
  props: {
    ruleForm: {
      type: Object,
      required: true
    }
  }

};
</script>

<style scoped>
span {
  color: #666;
}
</style>
